import { Dialog, Popover } from '@mui/material'
import { useState } from 'react'
import { PRESCRIPTION_BUILDER_VIEW_TYPES } from 'src/consumer/constants'
import {
  commonStylesPrescriptionSelect,
  loadOptionsAdvice,
} from '../../PrescriptionMakingPageComponents'
import { ObservationsCreatableSelect } from '../../PrescriptionMakingPageStyles'
import HealthEntityAddPopover from '../common/HealthEntityAddPopover'
import PrescriptionPillViewInputComponent from '../common/PrescriptionPillViewInputComponent'
import PrescriptionTableViewInputComponent from '../common/PrescriptionTableViewInputComponent'
import PrescriptionAdviceContextForm from './components/PrescriptionAdviceContextForm'
import AdviceFrequentlyUsedCheckboxes from './components/AdviceFrequentlyUsedCheckboxes'
import { handleChangeHealthEntityInputType1, handleKeyDownAndSupportEdit } from '../common/helpers'

export default function AdviceInputComponent({
  advices,
  setAdvices,
  clinicId,
  clinicBrandId,
  recommendedAdvices = [],
  prescriptionViewSettings,
  contextMenuSide,
}) {
  const [addAdviceButtonAnchor, setShowAddAdvice] = useState(false)
  const [adviceToCreate, setAdviceToCreate] = useState(null)

  const [inputValue, setInputValue] = useState('')

  async function createAdvice(adviceToAdd) {
    setAdvices((prev) => [...(prev || []), adviceToAdd])
    //fire api to create instruction
  }

  function onCreateAdvice(inputValue, e) {
    const adviceToAdd = {
      apiParam: 'prescription-advice',
      value: inputValue,
      label: inputValue,
      __isNew__: true,
    }
    setAdviceToCreate(adviceToAdd)
    if (!!e) {
      setShowAddAdvice(e.currentTarget)
    } else {
      setShowAddAdvice(true)
    }
  }

  switch (prescriptionViewSettings?.prescriptionBuilderViewType) {
    case PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView:
      return (
        <>
          <PrescriptionPillViewInputComponent
            additional={{
              page: 1,
              clinicId: clinicId,
              clinicBrandId: clinicBrandId,
              prescriptionViewSettings,
              recommendedAdvices,
            }}
            title="Advice"
            searchPlaceholder="Advice"
            onChange={(val) => setAdvices(val)}
            onCreate={onCreateAdvice}
            prescriptionViewSettings={prescriptionViewSettings}
            debounceTimeout={200}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            getOptionsResponse={loadOptionsAdvice}
            value={advices}
            itemName={'diagnosis'}
            // ContextMenuFormComponent={DiagnosisContextForm}
            contextMenuOpenSide={contextMenuSide}
            ContextMenuFormComponent={PrescriptionAdviceContextForm}
            showContextFormOnClickNewCondition={(item) => item?.__isNew__}
            useFullPageSearch={true}
          />
          <Dialog
            open={Boolean(addAdviceButtonAnchor)}
            onClose={() => {
              setShowAddAdvice(null)
            }}
          >
            <HealthEntityAddPopover
              healthEntity={adviceToCreate}
              addToHealthEntityArray={createAdvice}
              preferredLanguages={prescriptionViewSettings?.preferredPrescriptionLanguages}
              closePopover={() => setShowAddAdvice(null)}
              healthEntityName="Advice"
              apiParam="prescription-advice"
            />
          </Dialog>
        </>
      )
    case PRESCRIPTION_BUILDER_VIEW_TYPES.modern:
      return (
        <>
          <PrescriptionTableViewInputComponent
            value={advices}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            getOptionsResponse={loadOptionsAdvice}
            searchPlaceholder="Advice"
            onChange={(val) => setAdvices(val)}
            onCreate={onCreateAdvice}
            debounceTimeout={200}
            prescriptionViewSettings={prescriptionViewSettings}
            additional={{
              page: 1,
              clinicId: clinicId,
              clinicBrandId: clinicBrandId,
              prescriptionViewSettings,
              recommendedAdvices,
            }}
          />
          <Popover
            anchorEl={addAdviceButtonAnchor}
            open={Boolean(addAdviceButtonAnchor)}
            onClose={() => {
              setShowAddAdvice(null)
            }}
          >
            <HealthEntityAddPopover
              healthEntity={adviceToCreate}
              addToHealthEntityArray={createAdvice}
              preferredLanguages={prescriptionViewSettings?.preferredPrescriptionLanguages}
              closePopover={() => setShowAddAdvice(null)}
              healthEntityName={'Advice'}
              apiParam={'prescription-advice'}
            />
          </Popover>
        </>
      )
    default:
      return (
        <div 
          style={{ 
            width: '100%',
            position: 'relative',
            zIndex: 1000, // Ensure container has proper stacking context
          }}
        >
          <ObservationsCreatableSelect
            id="advice-select"
            classNamePrefix="advice_selection"
            closeMenuOnSelect={false}
            createOptionPosition="first"
            placeholder="Search or add new advice..."
            isMulti={true}
            isClearable={true}
            isSearchable={true}
            defaultOptions={false}
            loadOptions={loadOptionsAdvice}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            value={advices}
            onChange={(value) => {
              setAdvices(value)
            }}
            debounceTimeout={200}
            additional={{
              page: 1,
              clinicId: clinicId,
              clinicBrandId: clinicBrandId,
              prescriptionViewSettings,
              recommendedAdvices,
            }}
            styles={{
              ...commonStylesPrescriptionSelect,
              menuPortal: (provided, state) => ({
                ...provided,
                zIndex: 9999, // High z-index to appear above all other sections
              }),
              menu: (provided, state) => ({
                ...provided,
                ...commonStylesPrescriptionSelect.menu(provided, state),
                zIndex: 9999, // Ensure menu has high z-index
                position: 'absolute', // Ensure proper positioning
              }),
            }}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            menuPosition="fixed"
            inputValue={inputValue}
            onInputChange={(a, b) => {
              setInputValue((prev) => {
                if (prev === a) {
                  return prev
                }
                return a || ''
              })
              handleChangeHealthEntityInputType1(a, b, setAdvices)
            }}
            onKeyDown={(e) =>
              handleKeyDownAndSupportEdit(e, inputValue, advices, setAdvices, setInputValue)
            }
          />
          <AdviceFrequentlyUsedCheckboxes
            advices={advices}
            setAdvices={setAdvices}
            clinicId={clinicId}
            clinicBrandId={clinicBrandId}
            recommendedAdvices={recommendedAdvices}
            prescriptionViewSettings={prescriptionViewSettings}
          />
        </div>
      )
  }
}
